<div *ngIf="verifyType === 'email'">
    <div class="lock-container">
        <div class="lock-content">
            <div class="logo-section">
                <img class="logo" src="assets/images/logo.svg" alt="Rubii">
            </div>

            <div class="lock-message">
                <ng-container *ngIf="!errorType">
                    <h1 class="title">Two-factor verification</h1>
                    <p class="description">To ensure your account's security, we've sent a verification link to your email
                        address .</p>
                    <p class="description">Please click the link in the email to complete your login. This link will expire
                        in 15 minutes. </p>
                </ng-container>

                <ng-container *ngIf="errorType === 'expired'">
                    <h1 class="title">Your link is expired</h1>
                    <p class="description">For your security: the verification link we emailed you is only valid for short time. Please
                        click on resend email button to receive a new link.</p>
                    <p class="description-tips">Check your spam folder if you can’t find the email.</p>
                </ng-container>

                <ng-container *ngIf="errorType === 'paused'">
                    <h1 class="title">Verification paused</h1>
                    <p class="description">It looks like your last three verification attempts didn’t go through. You can try again in 15 minutes.
                    </p>
                    <p class="description">Need help? Our team is here — reach out at <a
                            href="mailto:support@rubii.io">support@rubii.io</a> and we’ll get you verified.
                    </p>
                </ng-container>

                 <ng-container *ngIf="errorType === 'locked'">
                    <h1 class="title">Your account has been temporarily locked</h1>
                    <p class="description">We’ve detected multiple failed verification attempts. For your security, your account has been temporarily disabled.
                    </p>
                    <p class="description">If you believe this is a mistake or need assistance regaining access, please contact Rubii Support at <a
                            href="mailto:support@rubii.io">support@rubii.io</a>.
                    </p>
                </ng-container>
                
                <button mat-raised-button class="rubii-btn" color="primary"
                    style="margin-top: 10px;margin-bottom: 10px;" *ngIf="!errorType || errorType === 'expired'" (click)="onResendEmail()">Resend email</button>
                <button mat-raised-button class="rubii-btn" color="primary"
                    style="margin-top: 10px;margin-bottom: 10px;" *ngIf="errorType && errorType !== 'expired'"  (click)="backToLogin()">Back to Login</button>
                <p class="description-tips" *ngIf="!errorType && isMobileVerified"><span (click)="onChangeToUsingMobile()" style="color: #E70F96;font-weight: 400;cursor: pointer;">Click here</span> if you have
                    issues with email verification and want to verify via
                    mobile number.</p>
                <p class="description" *ngIf="!errorType">Check your spam folder if you didn’t receive it</p>
            </div>
        </div>
    </div>
</div>

<div *ngIf="verifyType === 'mobile'">
    <div class="lock-container">
        <div class="lock-content">
            <div class="logo-section">
                <img class="logo" src="assets/images/logo.svg" alt="Rubii">
            </div>

            <div class="lock-message" *ngIf="!errorType">
                <h1 class="title">Two-factor verification</h1>
                <p class="description">To verify it’s you, we will send a OTP to your mobile number
                    {{maskedMobileNumber}}. Enter
                    the code below to verify.</p>
                <p class="description-tips">A verification code has been sent to your mobile number. Enter the code to
                    verify your
                    phone. </p>

                <div class="otp-input-container">
                    <app-otp-input [value]="otpValues[0]" [index]="0" [focused]="true"
                        [disabled]="isPaused || verifySuccess" (valueChange)="onValueChange($event)"
                        (moveNext)="onMoveNext($event)" (movePrevious)="onMovePrevious($event)"
                        (otpPaste)="onOtpPaste($event)"></app-otp-input>
                    <app-otp-input [value]="otpValues[1]" [index]="1" [focused]="false"
                        [disabled]="isPaused || verifySuccess" (valueChange)="onValueChange($event)"
                        (moveNext)="onMoveNext($event)" (movePrevious)="onMovePrevious($event)"
                        (otpPaste)="onOtpPaste($event)"></app-otp-input>
                    <app-otp-input [value]="otpValues[2]" [index]="2" [focused]="false"
                        [disabled]="isPaused || verifySuccess" (valueChange)="onValueChange($event)"
                        (moveNext)="onMoveNext($event)" (movePrevious)="onMovePrevious($event)"
                        (otpPaste)="onOtpPaste($event)"></app-otp-input>
                    <app-otp-input [value]="otpValues[3]" [index]="3" [focused]="false"
                        [disabled]="isPaused || verifySuccess" (valueChange)="onValueChange($event)"
                        (moveNext)="onMoveNext($event)" (movePrevious)="onMovePrevious($event)"
                        (otpPaste)="onOtpPaste($event)"></app-otp-input>
                    <app-otp-input [value]="otpValues[4]" [index]="4" [focused]="false"
                        [disabled]="isPaused || verifySuccess" (valueChange)="onValueChange($event)"
                        (moveNext)="onMoveNext($event)" (movePrevious)="onMovePrevious($event)"
                        (otpPaste)="onOtpPaste($event)"></app-otp-input>
                    <app-otp-input [value]="otpValues[5]" [index]="5" [focused]="false"
                        [disabled]="isPaused || verifySuccess" (valueChange)="onValueChange($event)"
                        (moveNext)="onMoveNext($event)" (movePrevious)="onMovePrevious($event)"
                        (otpPaste)="onOtpPaste($event)"></app-otp-input>
                </div>
                <div class="description-tips" style="color: #E70F96; cursor: pointer;" (click)="onResendOtp()">Resend Code <span *ngIf="countdown > 0">({{ countdown }}s)</span></div>
                <div class="otp-verification-msg">
                    <button mat-raised-button class="rubii-btn" color="primary"
                        style="margin-top: 10px;margin-bottom: 10px;" (click)="onSubmit()"
                        [disabled]="isVerifying || submitDisable">Submit</button>
                    <div class="otp-verifying-tip" *ngIf="isVerifying">
                        <mat-spinner color="primary" diameter="24"></mat-spinner>
                        <div>Verifying...</div>
                    </div>
                </div>


                <p class="description-tips">If you have issues with receiving OTP, please contact our support at
                    support@rubii.io
                </p>
            </div>
            
            <div class="lock-message" *ngIf="errorType === 'locked'">
                <h1 class="title">Your account has been temporarily locked</h1>
                <p class="description">We’ve detected multiple failed verification attempts. For your security, your account has been temporarily disabled.</p>
                <p class="description">If you believe this is a mistake or need assistance regaining access, please contact Rubii Support at  <a href="mailto:support@rubii.io">support@rubii.io</a>.</p>
                <button mat-raised-button class="rubii-btn" color="primary"
                    style="margin-top: 10px;margin-bottom: 10px;" (click)="backToLogin()">Back to Login</button>
            </div>

            <div class="lock-message" *ngIf="errorType === 'incomplete'">
                <h1 class="title">Verification incomplete</h1>
                <p class="description">You have not used our OTP for 3 times. Please try again after 15 minutes.</p>
                <p class="description">To regain access, please contact Rubii Support at <a
                        href="mailto:support@rubii.io">support@rubii.io</a> and we’ll help you complete the verification process.
                </p>
                <button mat-raised-button class="rubii-btn" color="primary" style="margin-top: 10px;margin-bottom: 10px;"
                    (click)="backToLogin()">Back to Login</button>
            </div>

             
        </div>
    </div>
</div>